import React from 'react';
import WindowIcon from '@mui/icons-material/Window';

export const SelectList = ({
                               list,
                               setSelectedValue,
                               heading,
                               labels: {text, value, subheading}
                           }) => {

    return (
        <div className="selectContainer">
            <h1 className="text-center title" style={{marginTop: '36px',marginBottom:'56px'}}>{heading}</h1>
            <ul>
                {list.map((item, i) => <li key={'listItem' + i}><a key={'anchor' + i} onClick={(e) => {
                    e.preventDefault();
                    setSelectedValue(item[value]);
                }}> <div className="orbitSelectInsideContainer">
                        {subheading ? <p>{item[subheading]}</p> : ''}<p>{item[text]}</p>
                    </div>
                    <i className="fa fa-angle-right" aria-hidden="true"></i></a></li>)}
            </ul>
        </div>
    )
}
